<template>
  <div class="p-lg">
    <h2 class="m-b-lg">{{ $t('configurator.chooseTourLong') }}</h2>
    <form>
      <div role="fieldset" class="flex products-container">
        <!--Todo: Consider outsource this into an own component like in extras -->
        <div class="product" v-for="product in products" :key="product.id">
          <card clickable class="card">
            <input
              type="radio"
              name="product"
              :id="product.id"
              :value="product.Title"
              tabindex="0"
              @click="product.bookable ? $emit('product-selected', product.id) : false"
              @keyup.enter="$emit('product-selected', product.id)"
              class="input-product"
            />
            <label
              :for="product.id"
              class="block pointer"
              :style="product.bookable ? '' : 'filter: grayscale(100%);'"
            >
              <span class="label-product -big">{{ product.Title }}</span>
              <styled-circle-button
                @click.prevent="
                  toggleModal({
                    title: product.Title,
                    description: product.Description,
                    teaserImage: product.TeaserImage,
                    galery: product.Galery
                  })
                "
                class="label-info"
                bgColor="#FF4444"
              >
                <icon name="info" />
              </styled-circle-button>
              <img
                :src="product.Icon ? assets.getUrl(product.Icon.url) : fallbackIcon"
                class="m-b-lg label-image align-center block"
                :alt="product.Title"
              />

              <span class="p-r-md p-l-md label-product -fine">
                {{ $t('configurator.price', { price: getPrice(product.Price) }) }}
                {{ $t('configurator.perPersonShort') }}
              </span>
            </label>
            <div v-if="product.ShortDescription" class="html-content p-l-md p-r-md p-t-xl">
              <vue-markdown>{{ product.ShortDescription }}</vue-markdown>
            </div>
            <styled-button
              @click="product.bookable ? $emit('product-selected', product.id) : false"
              @keyup.enter="$emit('product-selected', product.id)"
              :full-width="true"
              background-color="#404040"
            >
              {{ $t('configurator.chooseTour') }}
            </styled-button>
            <div v-if="!product.bookable" class="bookable-text">
              {{ product.bookableText }}
            </div>
          </card>
        </div>
      </div>
    </form>
    <modal class="modal" v-if="modalOpen" @close="toggleModal({})">
      <card class>
        <div
          class="modal-teaser"
          :style="
            `background-image: url(${
              modalContent.teaserImage ? assets.getUrl(modalContent.teaserImage.url) : ''
            }`
          "
        >
          <H2 class="p-l-xl p-b-md" font-family="Bitter" color="#ffffff" size="2rem">
            {{ modalContent.title }}
          </H2>
        </div>
        <div class="p-b-xl p-l-xl p-r-xl html-content">
          <vue-markdown>{{ modalContent.description }}</vue-markdown>
        </div>
        <div class="p-b-xl p-l-xl p-r-xl galery">
          <img
            v-for="img in modalContent.galery"
            :key="img.id"
            :src="assets.getUrl(img.formats.thumbnail.url)"
            :alt="img.alternativeText"
            class="galery-item"
          />
        </div>
      </card>
    </modal>
  </div>
</template>
<script>
import icon from 'vue-awesome/components/Icon.vue';
import vueMarkdown from 'vue-markdown';
import styledButton from '@/components/common/styledButton';
import card from '@/components/common/card';
import modal from '@/components/modal.vue';
import fallbackIcon from '@/assets/images/fallback_icon.png';
import styledCircleButton from '@/components/common/styledCircleButton';
import Currency from '@/utils/currency';
import { H2 } from '@/components/common/styledHeading';
import { assets } from '@/agent';

export default {
  name: 'product-selection',

  components: {
    styledButton,
    card,
    icon,
    modal,
    styledCircleButton,
    H2,
    vueMarkdown,
  },

  props: {
    products: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      fallbackIcon,
      modalOpen: false,
      modalContent: {},
      assets,
    };
  },

  methods: {
    getPrice(price) {
      return Currency.floatToEuro(price);
    },

    /**
     * Changes modal state to its opposite and content for product details.
     * @param {String} modalContent - The content for the modal
     */
    toggleModal(modalContent) {
      this.modalContent = modalContent;
      this.modalOpen = !this.modalOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.products-container {
  margin: 0 -1rem;
}

.card {
  position: relative;
}

.product {
  width: 100%;
  padding: 1rem;
  min-height: 15rem;

  @media screen and (min-width: 35rem) {
    width: calc(100% / 3);
  }
}

.input-product {
  opacity: 0;
  position: absolute;
  &:focus {
    opacity: 1;
  }
}

.label-product {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;

  &.-big {
    font-weight: 700;
    padding: 1rem 0;
    background-color: #404040;
    color: #ffffff;
  }

  &.-fine {
    font-weight: 700;
    line-height: 1.5;
  }
}

.label-info {
  position: absolute;
  top: 2rem;
  left: 1rem;
}

.label-image {
  object-fit: cover;
  max-height: 15rem;
  width: 100%;
}

.bookable-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgb(200, 0, 0);
  color: #fff;
  padding: 1rem 0.5rem;
  text-align: center;
}

.modal-teaser {
  position: relative;
  width: 100%;
  padding-top: 10rem;
  background-size: cover;
  background-position: center center;
}

.modal {

  .galery {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    justify-content: center;
    align-items: center;
  }

  .galery-item {
    width: 100%;
    max-width: 11.75rem;
  }
}
</style>
